export const SxStyles = {
  filter: 'drop-shadow(0px 2px 10px rgba(0,0,0,0.15))',
  '& .MuiPaper-root': {
    minWidth: '150px',
    overflow: 'visible',
    marginTop: '7px',
  },
  '& a': {
    color: 'inherit',
    textDecoration: 'none',
  },
  '& .MuiPaper-root:before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 5,
    width: 10,
    height: 10,
    bgcolor: 'background.paper',
    transform: 'translateY(-50%) rotate(45deg)',
    zIndex: 0,
  },
}
